import { Box, Typography } from "@mui/material";
import React from "react";

const FieldName = [
  // {
  //   name: "Name",
  //   value: "name",
  // },
  // {
  //   name: "Model",
  //   value: "model",
  // },
  // {
  //   name: "Owner Serial",
  //   value: "ownerSerial",
  // },
  {
    name: "Registration Type",
    value: "registrationType",
  },
  // {
  //   name: "Price",
  //   value: "price",
  // },
  // {
  //   name: "Year of Manufacture",
  //   value: "yearOfManufacture",
  // },
  // {
  //   name: "Variant",
  //   value: "variant",
  // },
  // {
  //   name: "Color",
  //   value: "color",
  // },
  {
    name: "Fuel Type",
    value: "fuelType",
  },
  {
    name: "Transmission",
    value: "transmission",
  },
  // {
  //   name: "Kilometers Driven",
  //   value: "kmsDriven",
  // },
  {
    name: "Status",
    value: "status",
  },
  {
    name: "Insurance Expiry Date",
    value: "insuranceExpiryDate",
    type: "date",
  },
  {
    name: "Registration Expiry Date",
    value: "registrationExpiryDate",
    type: "date",
  },
  {
    name:"Registration Date",
    value:"registrationDate",
    type:"date"
  },
  {
    name: "Chassis Number",
    value: "chassisNumber",
  },
  {
    name: "Inventory Type",
    value: "inventoryType",
  },
  // {
  //   name: "Vehicle Number",
  //   value: "vehicleNumber",
  // },
  // {
  //   name: "Engine Number",
  //   value: "engineNumber",
  // },
];

const AdditionalInfo = ({ data }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "2rem",
          borderRadius: "0.5rem",
          border: "1px solid",
          borderColor: "grey.200",
          mt: "1rem",
          width: "80%",
        }}
        className="bg-black/10"
      >
        <Typography variant="h4" component="span" className="font-extrabold">
          Additional Details
        </Typography>

        {FieldName.map((item) => (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              borderRadius: "0.5rem",
              width: "100%",
              gap: "1rem",
              padding: "0.5rem",
            }}
            key={item.value}
          >
            <Typography variant="h6" component="span">
              {item.name}
            </Typography>
            <Typography variant="h6" component="span">
              {item?.type !== "date" ? data[item.value] : ""}
              {item?.type === "date"
                ? new Date(data[item.value]).toDateString({
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : ""}
            </Typography>
          </Box>
        ))}
        {data?.dealer && (
          <>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                borderRadius: "0.5rem",
                width: "100%",
                gap: "1rem",
                padding: "0.5rem",
              }}
            >
              <Typography variant="h6" component="span">
                Dealer Name
              </Typography>
              <Typography variant="h6" component="span">
                {data?.dealer?.name}
              </Typography>
              <Typography variant="h6" component="span">
                Dealer Address
              </Typography>
              <Typography variant="h6" component="span">
                {data?.dealer?.address}
              </Typography>
              <Typography variant="h6" component="span">
                Dealer Contact
              </Typography>
              <Typography variant="h6" component="span">
                {data.dealer?.contact?.map((phone, key) => (
                  <Typography key={key} variant="h6" component="span">
                    {phone}
                  </Typography>
                ))}
              </Typography>
              <Typography variant="h6" component="span">
                Dealer Email
              </Typography>
              <Typography variant="h6" component="span">
                {data.dealer?.email?.map((email, key) => (
                  <Typography key={key} variant="h6" component="span">
                    {email}
                  </Typography>
                ))}
              </Typography>
            </Box>
          </>
        )}
        {data?.owner && (
          <>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                borderRadius: "0.5rem",
                width: "100%",
                gap: "1rem",
                padding: "0.5rem",
              }}
            >
              <Typography variant="h6" component="span">
                Owner Name
              </Typography>
              <Typography variant="h6" component="span">
                {data?.owner?.name}
              </Typography>
              <Typography variant="h6" component="span">
                Owner Address
              </Typography>
              <Typography variant="h6" component="span">
                {data?.owner?.address}
              </Typography>
              <Typography variant="h6" component="span">
                Owner Contact
              </Typography>
              <Typography variant="h6" component="span">
                {data.owner?.contact?.map((phone, key) => (
                  <Typography key={key} variant="h6" component="span">
                    {phone}
                  </Typography>
                ))}
              </Typography>
              <Typography variant="h6" component="span">
                Owner Email
              </Typography>
              <Typography variant="h6" component="span">
                {data.owner?.email?.map((email, key) => (
                  <Typography key={key} variant="h6" component="span">
                    {email}
                  </Typography>
                ))}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};

export default AdditionalInfo;
